import { FluentStyles } from '@uifabric/fluent-theme/lib/fluent/FluentStyles';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled, setFeatureFlagAction } from 'owa-feature-flags';
import { Customizations, GlobalSettings, ICustomizations } from '@uifabric/utilities';
import { loadTheme, getTheme } from '@uifabric/styling';
import FluentTheme from '@uifabric/fluent-theme/lib/fluent/FluentTheme';

export default function loadFluentFabric(
    isFluentEnabled: boolean = isFeatureEnabled('fwk-fluentFabric')
) {
    let _allSettings = GlobalSettings.getValue<ICustomizations>('customizations', {
        settings: {},
        scopedSettings: {},
        inCustomizerContext: false,
    });

    Object.keys(FluentStyles).forEach(scope => {
        _allSettings.scopedSettings[scope] = {
            ..._allSettings.scopedSettings[scope],
            ...(isFluentEnabled ? FluentStyles[scope] : {}),
        };
    });

    const {
        // The semantic colors, if not provided, will be computed from our provided palette
        // If we pass along Fluent's semanticColors, it will trample over our theme palette
        semanticColors = undefined,

        palette: fluentPalette = undefined,
        ...fluentEffects
    } = isFluentEnabled ? FluentTheme : {};

    const { palette, isInverted, fonts } = getTheme();

    loadTheme({
        ...fluentEffects,
        fonts,
        isInverted,
        palette: {
            ...fluentPalette,
            ...palette,
        },
    });

    // Call this with a blank settings object in order to raise a change event for all the above changes.
    // Calling Customizations.applyScopedSettings on each scope is too slow, and there's no other "proper" way
    // to raise a change event
    Customizations.applySettings({});

    document.body.classList[isFluentEnabled ? 'add' : 'remove']('fabric-fluent');
}

orchestrator(setFeatureFlagAction, ({ feature, isOn }) => {
    if (feature === 'fwk-fluentFabric') {
        loadFluentFabric(isOn);
    }
});
